import * as React from "react";
import * as ReactDOM from "react-dom";
import { variables } from '../Variables';
import axios from 'axios';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import allLocales from '@fullcalendar/core/locales-all';
import interactionPlugin from "@fullcalendar/interaction";
import timeGridPlugin from '@fullcalendar/timegrid';
import { DateFormatter } from '@fullcalendar/core';
import { useSelector, useDispatch } from "react-redux";
import { setCalendarView } from "../features/CalendarSelectedViewSlice";
import calLoader from '../assets/images/calendar-loader.svg';
import el from "date-fns/locale/el/index.js";
import { DuplicateEventsRemove } from "../utils/DuplicateEventsRemove";

const { useState, useRef, useEffect } = React;
export const Schedular = ({ showMessageBox, selectedProperty, calendarRef, calendarEvents, tobeConfirmedIds, confirmedIds, freeSlotIds, eventClickHandler,
    selectedAgentsList, selectedStatusAction, showCalendarLoader, getWhiseCalenderEvents, setShowCalendarLoader, currentRange, toLocalISOString,
    setEstateListContainEvent, setEstateIdsHavingFreeSlotsInFutureOrPast, showSynchingLoader }) => {
    const [calendarActions, setCalendarActions] = useState([]);
    const [events, setEvents] = useState([]);
    const [currentView, setCurrentView] = useState('timeGridWeek'); // Track the current view

    var days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thur', 'Fri', 'Sat'];
    var daysFullname = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const whiseUserToken = useSelector(state => state.whiseUser.whiseToken);
    const actions = useSelector(state => state.calendarActions.calendarActions);
    const reduxCalendarView = useSelector(state => state.calendarView.calendarView);
    const reduxSelectedLanguage = useSelector(state => state.selectedLanguageTranslations.selectedLanguage);
    const dispatch = useDispatch();

    const reduxLanguageTranslations = useSelector(state => state.selectedLanguageTranslations.selectedLanguageTranslations);

    const getStatus = (actionId) => {
        if (tobeConfirmedIds.indexOf(actionId) !== -1) {
            return "To Be Confirmed";
        }
        else if (confirmedIds.indexOf(actionId) !== -1) {
            return "Confirmed";
        } else if (freeSlotIds.indexOf(actionId) !== -1) {
            return "Free Slot";
        } else {
            return '';
        }
    }

    const getAction = (actionId) => {
        let action = calendarActions.filter((d) => d.id === actionId);
        if (action.length > 0) {
            return action[0].name;
        }
        else {
            return "";
        }
    }

    const getBackGround = (actionId) => {
        if (tobeConfirmedIds.indexOf(actionId) !== -1) {
            return "#B0B0B0";
        }
        else if (confirmedIds.indexOf(actionId) !== -1) {
            return "#15C31C";
        }
        else if (freeSlotIds.indexOf(actionId) !== -1) {
            return "#B0B0B0";
        }
        else {
            return "";
        }
    }

    const getIsMatchedWithUser = (event) => {
        if (!event || !Array.isArray(event.users) || event.users.length === 0) {
            return false; // Return false if users array is invalid or empty
        }

        const eventUserId = event.users[0].userId;

        const userExistInEvent = selectedAgentsList.filter(item => item.value === eventUserId);

        return userExistInEvent.length > 0;
    };

    const getIsEventMatchedWithSettings = (event) => {
        if (tobeConfirmedIds.indexOf(event.action.id) !== -1 || confirmedIds.indexOf(event.action.id) !== -1 || freeSlotIds.indexOf(event.action.id) !== -1) {
            return true;
        }
        else {
            return false;
        }
    }

    const getWeekdayDate = (startDate, day) => {
        const daysMap = {
            SU: 0,
            MO: 1,
            TU: 2,
            WE: 3,
            TH: 4,
            FR: 5,
            SA: 6,
        };
        const targetDay = daysMap[day];
        if (targetDay === undefined) return null;

        const currentDay = startDate.getDay();
        const difference = targetDay - currentDay;
        const resultDate = new Date(startDate);
        //resultDate.setDate(startDate.getDate() + (difference >= 0 ? difference : difference + 7));
        resultDate.setDate(startDate.getDate() + difference);
        return resultDate;
    };

    //const generateRecurringDates = (
    //    startDateTime,
    //    patternEndDate,
    //    pattern,
    //    currentRangeStart,
    //    currentRangeEnd
    //) => {
    //    const recurringDates = [];
    //    const frequency = pattern.match(/FREQ=(\w+)/)?.[1]; // Extract FREQ
    //    const interval = parseInt(pattern.match(/INTERVAL=(\d+)/)?.[1] || "1", 10); // Extract INTERVAL (default to 1)
    //    const byDay = pattern.match(/BYDAY=([A-Z,]+)/)?.[1]?.split(",") || []; // Extract BYDAY
    //    const start = new Date(startDateTime); // Original start date


    //    // Default patternEndDate to the end of the current week if undefined
    //    const today = new Date();
    //    const endOfWeek = new Date(today);
    //    endOfWeek.setDate(today.getDate() + (7 - today.getDay())); // Set to Sunday of this week
    //    const end = patternEndDate ? new Date(patternEndDate) : endOfWeek;

    //    //const end = new Date(patternEndDate);
    //    const rangeStart = new Date(currentRangeStart);
    //    const rangeEnd = new Date(currentRangeEnd);

    //    if (!frequency) {
    //        console.error("Invalid pattern: FREQ is missing");
    //        return [];
    //    }

    //    let current = start;

    //    while (current <= end) {
    //        // Only process dates within the currentRange
    //        if (current >= rangeStart && current <= rangeEnd) {
    //            if (frequency === "WEEKLY") {
    //                // Handle weekly recurrence based on BYDAY
    //                const weekStart = new Date(current); // Ensure weekStart is a fresh date
    //                byDay.forEach((day) => {
    //                    if (toLocalISOString(weekStart) !== toLocalISOString(start)) {
    //                        const weekDayDate = getWeekdayDate(weekStart, day); // Compute for this week
    //                        if (
    //                            weekDayDate >= rangeStart &&
    //                            weekDayDate <= rangeEnd &&
    //                            weekDayDate <= end
    //                        ) {
    //                            recurringDates.push(toLocalISOString(weekDayDate));
    //                        }
    //                    }
    //                    else {
    //                        const newDate = toLocalISOString(start);
    //                        if (!recurringDates.includes(newDate)) {
    //                            recurringDates.push(newDate);
    //                        }
    //                    }
    //                });
    //                current.setDate(current.getDate() + interval * 7); // Advance by interval weeks
    //            } else if (frequency === "DAILY") {
    //                recurringDates.push(toLocalISOString(current));
    //                current.setDate(current.getDate() + interval);
    //            } else if (frequency === "MONTHLY") {
    //                recurringDates.push(toLocalISOString(current));
    //                current.setMonth(current.getMonth() + interval);
    //            } else if (frequency === "YEARLY") {
    //                recurringDates.push(toLocalISOString(current));
    //                current.setFullYear(current.getFullYear() + interval);
    //            } else {
    //                console.error("Unsupported frequency:", frequency);
    //                break;
    //            }
    //        } else {
    //            // If current is out of range, increment based on frequency and continue
    //            if (frequency === "WEEKLY") {
    //                current.setDate(current.getDate() + interval * 7);
    //            } else if (frequency === "DAILY") {
    //                current.setDate(current.getDate() + interval);
    //            } else if (frequency === "MONTHLY") {
    //                current.setMonth(current.getMonth() + interval);
    //            } else if (frequency === "YEARLY") {
    //                current.setFullYear(current.getFullYear() + interval);
    //            } else {
    //                console.error("Unsupported frequency:", frequency);
    //                break;
    //            }
    //        }
    //    }

    //    return recurringDates;
    //};

    const generateRecurringDates = (
        startDateTime,
        patternEndDate,
        pattern,
        currentRangeStart,
        currentRangeEnd
    ) => {
        const recurringDates = [];
        const frequency = pattern.match(/FREQ=(\w+)/)?.[1]; // Extract FREQ
        const interval = parseInt(pattern.match(/INTERVAL=(\d+)/)?.[1] || "1", 10); // Extract INTERVAL (default to 1)
        const byDay = pattern.match(/BYDAY=([A-Z,]+)/)?.[1]?.split(",") || []; // Extract BYDAY

        if (!frequency) {
            console.error("Invalid pattern: FREQ is missing");
            return [];
        }

        const start = new Date(startDateTime);
        const end = patternEndDate ? new Date(patternEndDate) : new Date(start);
        const rangeStart = new Date(currentRangeStart);
        const rangeEnd = new Date(currentRangeEnd);

        // Map BYDAY values to European week format (Monday = 1, Sunday = 7)
        const dayMap = { MO: 1, TU: 2, WE: 3, TH: 4, FR: 5, SA: 6, SU: 7 };
        const targetDays = byDay.map(day => dayMap[day]).sort((a, b) => a - b);

        let current = new Date(start);

        // First occurrence must be the same as startDateTime
        if (current >= rangeStart && current <= rangeEnd && current <= end) {
            recurringDates.push(toLocalISOString(current));
        }

        while (current <= end) {
            if (frequency === "WEEKLY") {
                let baseWeekStart = new Date(current);
                baseWeekStart.setDate(baseWeekStart.getDate() - (baseWeekStart.getDay() || 7) + 1); // Adjust to Monday

                targetDays.forEach(day => {
                    let occurrence = new Date(baseWeekStart);
                    occurrence.setDate(baseWeekStart.getDate() + (day - 1));

                    if (
                        occurrence > start && // Must be after the event start date
                        occurrence >= rangeStart &&
                        occurrence <= rangeEnd &&
                        occurrence <= end &&
                        !recurringDates.includes(toLocalISOString(occurrence))
                    ) {
                        recurringDates.push(toLocalISOString(occurrence));
                    }
                });

                // Move forward by interval weeks
                current.setDate(current.getDate() + interval * 7);
            } else if (frequency === "DAILY") {
                current.setDate(current.getDate() + interval);
                if (current > start && current <= end && !recurringDates.includes(toLocalISOString(current))) {
                    recurringDates.push(toLocalISOString(current));
                }
            } else if (frequency === "MONTHLY") {
                current.setMonth(current.getMonth() + interval);
                if (current > start && current <= end && !recurringDates.includes(toLocalISOString(current))) {
                    recurringDates.push(toLocalISOString(current));
                }
            } else if (frequency === "YEARLY") {
                current.setFullYear(current.getFullYear() + interval);
                if (current > start && current <= end && !recurringDates.includes(toLocalISOString(current))) {
                    recurringDates.push(toLocalISOString(current));
                }
            } else {
                console.error("Unsupported frequency:", frequency);
                break;
            }
        }

        return recurringDates;
    };

    useEffect(() => {
        if (
            calendarEvents &&
            calendarEvents.length > 0 &&
            calendarActions.length > 0 &&
            selectedProperty &&
            currentRange.start && currentRange.end &&
            freeSlotIds.length > 0 &&
            tobeConfirmedIds.length > 0 &&
            confirmedIds.length > 0
        ) {
            // Memoize status dropdown values
            const statusDropdownValues = selectedStatusAction.reduce((acc, item) => {
                if (item._freeSlotIds) acc.push(...item._freeSlotIds);
                if (item.beforeConfirmationIds) acc.push(...item.beforeConfirmationIds);
                if (item.afterConfirmationIds) acc.push(...item.afterConfirmationIds);
                return acc;
            }, []);

            //create array of calendar actions saved in the settings screen
            let savedCalendarActions = [...freeSlotIds, ...tobeConfirmedIds, ...confirmedIds];
            savedCalendarActions = [...new Set(savedCalendarActions)];

            let eventEstates = [];
            let _estateIdsHavingFreeSlotsInFutureOrPast = [];

            // Process events to check conditions and assign backgroundColor
            const eventsList = calendarEvents.map((event) => {
                // Check if the event's action.id matches any value in calendarActions
                const hasMatchingAction = savedCalendarActions.includes(event.action?.id);

                // Check if any EstateId matches the selectedProperty.id
                const hasMatchingEstate = event.estates?.some(
                    (estate) => estate.estateId === selectedProperty?.id
                );

                // Apply additional check for dropdown only when it has selected values
                const isMatchedWithDropdown = statusDropdownValues.length > 0
                    ? statusDropdownValues.includes(event.action?.id)
                    : true;

                let eventDate = new Date(event.startDateTime);
                let currentDate = new Date();
                if (event.estates != undefined && event.estates.length > 0 && eventDate > currentDate && freeSlotIds.indexOf(event.action.id) != -1) {
                    eventEstates.push(event.estates[0].estateId);
                }
                if (event.estates != undefined && event.estates.length > 0 && freeSlotIds.indexOf(event.action.id) != -1) {
                    _estateIdsHavingFreeSlotsInFutureOrPast.push(event.estates[0].estateId);
                }

                // Determine `isMatched` by combining the conditions, including the dropdown check
                const isMatched = hasMatchingAction && hasMatchingEstate && isMatchedWithDropdown;
                //const isMatched = hasMatchingAction && hasMatchingEstate;
                const backgroundColor = isMatched ? "#ECF1FF" : "rgb(243 243 243)";

                const eventObject = {
                    id: event.id,
                    title: event.subject,
                    start: event.startDateTime,
                    end: event.endDateTime,
                    backgroundColor,
                    extendedProps: {
                        status: getStatus(event.action.id),
                        eventAction: getAction(event.action.id),
                        background: getBackGround(event.action.id),
                        fullName: event.users?.[0]?.name || "",
                        firstLetter: event.users?.[0]?.name?.charAt(0) || "",
                        isMatched,
                        action: event.action.id,
                        estateId: event.estates?.[0]?.estateId || 0,
                        italic: false,
                        eventId: event.id,
                        users: event.users || [],
                        estates: event.estates || [],
                        contacts: event.contacts || [],
                        startDateTime: event.startDateTime,
                        endDateTime: event.endDateTime,
                        isLocalDbEvent: !!event.isLocalDbEvent
                    },
                };
                if (event.pattern) {
                    eventObject.extendedProps.recurringStartDates = generateRecurringDates(
                        event.startDateTime,
                        event.patternEndDate,
                        event.pattern,
                        currentRange.start,
                        currentRange.end
                    );
                    eventObject.extendedProps.pattern = event.pattern;
                    eventObject.extendedProps.patternEndDate = event.patternEndDate;
                }
                return eventObject;

            });

            setEstateListContainEvent(eventEstates);
            setEstateIdsHavingFreeSlotsInFutureOrPast(_estateIdsHavingFreeSlotsInFutureOrPast);

            // Filter recurring events based on currentRange
            const recurringEventsList = eventsList.flatMap((event) => {
                if (event.extendedProps.recurringStartDates?.length > 0) {
                    return event.extendedProps.recurringStartDates
                        .filter((date) => {
                            const eventDate = new Date(date);
                            const rangeStart = new Date(currentRange.start);
                            const rangeEnd = new Date(currentRange.end);
                            return eventDate >= rangeStart && eventDate <= rangeEnd;
                        })
                        .map((recurringDate, i) => ({
                            ...event,
                            id: event.id++,
                            start: toLocalISOString(new Date(recurringDate)),
                            end: toLocalISOString(new Date(
                                new Date(recurringDate).getTime() +
                                (new Date(event.end).getTime() - new Date(event.start).getTime())
                            )),
                        }));
                }
                return [];
            });

            const filteredEventsList = eventsList.filter(
                (event) => !event.extendedProps.recurringStartDates?.length
            );

            //console.log([...filteredEventsList, ...recurringEventsList]);
            const uniqueEvents = DuplicateEventsRemove([...filteredEventsList, ...recurringEventsList]);
            //console.log(uniqueEvents);
            setEvents(uniqueEvents);

            //setEvents([...filteredEventsList, ...recurringEventsList]);
            //setShowCalendarLoader(false);

        } else {
            setEvents([]);
            //setShowCalendarLoader(false);
        }
    }, [calendarEvents, calendarActions, selectedStatusAction, selectedAgentsList, selectedProperty]);

    const handlerOnChangeCalendarView = (view) => {
    }

    useEffect(() => {
        if (actions != null && actions != undefined) {
            setCalendarActions(actions);
        }
    }, [actions])

    return (
        <>
            <div className={`form-container position-relative ${showCalendarLoader ? "d-none" : ""}`}>
                <div className="schedular-container" id="schedularContainer">
                    <FullCalendar
                        ref={calendarRef}
                        editable
                        selectable
                        events={events}
                        firstDay={1}
                        locales={allLocales}
                        locale={reduxSelectedLanguage ? reduxSelectedLanguage : 'en-GB'}
                        columnFormat={
                            {
                                week: 'ddd D/M',
                            }
                        }
                        eventContent={(data) => {
                            let startDate = data.event.start;
                            let endDate = data.event.end || startDate;
                            let startTime = startDate.getTime();
                            let endTime = endDate.getTime();

                            var diff = (startTime - endTime) / 1000;
                            diff /= 60;

                            let timeDifference = Math.abs(Math.round(diff));

                            let action = data.event._def.extendedProps.eventAction;

                            if (data.event._def.extendedProps.status == "Free Slot" || data.event._def.extendedProps.status == "To Be Confirmed" || data.event._def.extendedProps.status == "Confirmed") {
                                action = reduxLanguageTranslations ? reduxLanguageTranslations["calendarPageEventStatusVisitLbl"] : "Visit";
                            }

                            let eventStatus = "";
                            if (data.event._def.extendedProps.status == "Free Slot") {
                                eventStatus = reduxLanguageTranslations ? reduxLanguageTranslations["calendarPageFilterDropdownStatusOptionFreeSl"] : "Free Slot";
                            } else if (data.event._def.extendedProps.status == "Confirmed") {
                                eventStatus = reduxLanguageTranslations ? reduxLanguageTranslations["calendarPageFilterDropdownStatusOptionConfirmed"] : "Confirmed";
                            } else {
                                eventStatus = reduxLanguageTranslations ? reduxLanguageTranslations["calendarPageFilterDropdownStatusOptionToBeConfirm"] : "To Be Confirmed";
                            }

                            if (endTime > startTime && (timeDifference == 0 || timeDifference > 30)) {
                                return <div className={`event-container`} id={data.event._def.extendedProps.eventId} estateid={data.event._def.extendedProps.estateId}>
                                    <div className="d-flex justify-content-between align-items-center mb-1">
                                        <div className="d-flex mb-0">
                                            <span className={`text-dark me-2 ${data.event._def.extendedProps.pattern ? "" : "d-none"}`} title="Recurrence">R</span>
                                            <span className={`event-action ${data.event._def.extendedProps.isMatched == true && !data.event._def.extendedProps.pattern ? "blue" : "grey"} ${data.event._def.extendedProps.italic == true ? "italic" : ""}`}>{action}</span>
                                        </div>
                                        <span className={`rounded-circle ${data.event._def.extendedProps.isMatched == true ? "" : "grey-bg"}`} title={data.event._def.extendedProps.fullName}>{data.event._def.extendedProps.firstLetter}</span>

                                    </div>
                                    {
                                        eventStatus != '' ?
                                            <div className='status text-white'
                                                style={{ background: data.event._def.extendedProps.background }} >
                                                {eventStatus}
                                            </div>
                                            : null
                                    }
                                </div>
                            }
                            else {
                                let classess = "align-items-center";
                                let circleClasses = "rounded-circle";
                                if (timeDifference <= 30 & timeDifference >= 25) {
                                    classess = "line-height-11 align-items-center pt-0-55"
                                }
                                else if (timeDifference < 25 & timeDifference >= 20) {
                                    classess = "line-height-11 align-items-center pt-0-05"
                                }
                                else if (timeDifference < 20 & timeDifference >= 15) {
                                    classess = "line-height-11 align-items-top pt-0-05";
                                    circleClasses = "rounded-circle m-top-neg-3";
                                }
                                else if (timeDifference < 15 & timeDifference >= 10) {
                                    classess = "line-height-8 align-items-top pt-0";
                                    circleClasses = "rounded-circle-small";
                                }

                                return <div className={`event-container d-flex justify-content-between ${classess}`} id={data.event._def.extendedProps.eventId} estateid={data.event._def.extendedProps.estateId}>
                                    <p>
                                        <span className={`text-dark me-2 ${data.event._def.extendedProps.pattern ? "" : "d-none"}`} title="Recurrence">R</span>
                                        <span className={`event-action ${data.event._def.extendedProps.isMatched == true && !data.event._def.extendedProps.pattern ? "blue" : "grey"} ${data.event._def.extendedProps.italic == true ? "italic" : ""}`}>{action}</span>
                                    </p>
                                    <p className="d-flex mb-0">
                                        {
                                            data.event._def.extendedProps.status != '' ?
                                                <span className={`${circleClasses}`} style={{ background: data.event._def.extendedProps.background }} title={eventStatus}>
                                                    {
                                                        eventStatus.split("")[0]
                                                    }
                                                </span>
                                                : null
                                        }
                                        <span className={`${circleClasses} ${data.event._def.extendedProps.isMatched == true ? "" : "grey-bg"}`} title={data.event._def.extendedProps.fullName}>{data.event._def.extendedProps.firstLetter}</span>
                                    </p>
                                </div>
                            }
                        }}
                        headerToolbar={{
                            start: "today prev next",
                            center: "title",
                            end: "timeGridDay timeGridWeek dayGridMonth"
                        }}
                        slotEventOverlap={false}
                        plugins={[timeGridPlugin, dayGridPlugin, interactionPlugin]}
                        views={{
                            dayGridMonth: {
                                titleFormat: { year: 'numeric', month: 'long' }  // E.g., "September 2024"
                            },
                            timeGridWeek: {
                                titleFormat: { year: 'numeric', month: 'short', day: '2-digit' } // E.g., "Sep 26 - Oct 2, 2024"
                            },
                            timeGridDay: {
                                titleFormat: { year: 'numeric', month: 'long', day: '2-digit' }  // E.g., "September 26, 2024"
                            }
                        }}
                        initialView={currentView}
                        datesSet={handlerOnChangeCalendarView}
                        eventClick={eventClickHandler}
                        businessHours={[ // specify an array instead
                            {
                                daysOfWeek: [0, 1, 2, 3, 4, 5, 6],
                                startTime: '08:00',
                                endTime: '22:00'
                            }
                        ]}
                        //height="auto"
                        contentHeight={600}
                        slotDuration='01:00'
                        allDaySlot={false}
                        customButtons={{
                            today: {
                                text: reduxLanguageTranslations ? reduxLanguageTranslations["calendarTodayButtonLabel"] : 'today',
                                click: async () => {
                                    setShowCalendarLoader(true);
                                    const calendarApi = calendarRef.current.getApi();
                                    calendarApi.today(); // Move to the previous range
                                    const view = calendarApi.view;
                                    const start = view.activeStart; // Start date of the visible range
                                    const end = view.activeEnd; // End date of the visible range
                                    setCurrentView(view.type);
                                    await getWhiseCalenderEvents("onAction", start, end, view.type);
                                },
                            },
                            prev: {
                                click: async () => {
                                    setShowCalendarLoader(true);
                                    const calendarApi = calendarRef.current.getApi();
                                    calendarApi.prev(); // Move to the previous range
                                    const view = calendarApi.view;
                                    const start = view.activeStart; // Start date of the visible range
                                    const end = view.activeEnd; // End date of the visible range
                                    setCurrentView(view.type);
                                    await getWhiseCalenderEvents("onAction", start, end, view.type);
                                },
                            },
                            next: {
                                click: async () => {
                                    setShowCalendarLoader(true);
                                    const calendarApi = calendarRef.current.getApi();
                                    calendarApi.next(); // Move to the next range
                                    const view = calendarApi.view;
                                    const start = view.activeStart; // Start date of the visible range
                                    const end = view.activeEnd; // End date of the visible range
                                    setCurrentView(view.type);
                                    await getWhiseCalenderEvents("onAction", start, end, view.type);
                                },
                            },
                            dayGridMonth: {
                                text: reduxLanguageTranslations ? reduxLanguageTranslations["calendarMonthButtonLabel"] : 'month',
                                click: async () => {
                                    setShowCalendarLoader(true);
                                    const calendarApi = calendarRef.current.getApi();
                                    calendarApi.changeView('dayGridMonth');
                                    const view = calendarApi.view;
                                    const start = view.activeStart; // Start date of the visible range
                                    const end = view.activeEnd; // End date of the visible range
                                    await getWhiseCalenderEvents("onAction", start, end, view.type);
                                }
                            },
                            timeGridWeek: {
                                text: reduxLanguageTranslations ? reduxLanguageTranslations["calendarWeekButtonLabel"] : 'week',
                                click: async () => {
                                    setShowCalendarLoader(true);
                                    const calendarApi = calendarRef.current.getApi();
                                    calendarApi.changeView('timeGridWeek');
                                    const view = calendarApi.view;
                                    const start = view.currentStart; // Start date of the visible range
                                    const end = view.currentEnd; // End date of the visible range
                                    await getWhiseCalenderEvents("onAction", start, end, view.type);
                                }
                            },
                            timeGridDay: {
                                text: reduxLanguageTranslations ? reduxLanguageTranslations["calendarDayButtonLabel"] : 'day',
                                click: async () => {
                                    setShowCalendarLoader(true);
                                    const calendarApi = calendarRef.current.getApi();
                                    calendarApi.changeView('timeGridDay');
                                    const view = calendarApi.view;
                                    const start = view.activeStart; // Start date of the visible range
                                    const end = view.activeEnd; // End date of the visible range
                                    await getWhiseCalenderEvents("onAction", start, end, view.type);
                                }
                            }
                        }}
                    />
                </div>
            </div>
            <div className={`form-container position-relative ${showCalendarLoader == false ? "d-none" : ""}`}>
                <div className="schedular-container">
                    <div className={`calendar-loader`}>
                        <div className="form-container text-center">
                            <img src={calLoader} className="cal-loader py-3" />
                            <p className="m-0 pt-2 pb-2">
                                {
                                    showSynchingLoader == true ? 
                                        <>{reduxLanguageTranslations ? reduxLanguageTranslations["synchingLoaderText"] : "Please wait! Events synchronization is in progress"}</>
                                        :
                                        <>{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPageLoaderText"] : "One moment we preparing the overview with the visits that already exist for the agent and the property"}</>
                                }
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}